// import Nav from "react-bootstrap/Nav";
// import Navbar from "react-bootstrap/Navbar";
// import { Navigate, NavLink, useNavigate } from "react-router-dom";
// import "./Header.css";
// import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { useState, useContext, useEffect } from "react";
// import { Dot_Lottie } from "../common/lotties/dot-lottie/Dot_Lottie";
// import { PowerProgress } from "../../utils/apis/homepage";
// import { IDS } from "../../utils/common";
// import { Context } from "../../utils/context";
// import { useLocation, Link } from "react-router-dom";

// const Header = () => {
//   const navigate = useNavigate();
//   const [expanded, setExpanded] = useState(false);

//   const { IMG_URL } = useContext(Context);

//   const [appsetup, setAppSetup] = useState({});
//   const location = useLocation();

//   const getAppSetup = async () => {
//     const res = await PowerProgress();

//     if (res?.success) {
//       setAppSetup(res?.data?.[0] || {});
//     }
//   };

//   useEffect(() => {
//     getAppSetup();
//   }, []);

//   return (
//     <section className="header_section">
//       <div className="top-bar">
//         <div className="top-bar-inner container">
//           <div className="logo-wrapper" onClick={() => navigate("/")}>
//             <img
//               src={IDS?.IMG_URL + appsetup?.logo}
//               // src="/assets/images/newhome/homelogo.png"
//               alt="Hindustan Solar"
//               className="top-logo"
//             />
//           </div>
//           <div className="top-contact">
//             <div className="contact-btn">
//               <div className="button_holder">
//                 <button
//                   className="subsidy-btn-mobile"
//                   onClick={() => navigate("/subsidy-policy")}
//                 >
//                   <Dot_Lottie /> Subsidy & Policies
//                 </button>
//               </div>
//             </div>
//             <div className="contact-item">
//               <FontAwesomeIcon icon={faPhone} />
//               <div className="label">
//                 <p>Contact Number:</p>
//                 <p className="value">{appsetup.contactno}</p>
//               </div>
//             </div>
//             <div className="divider" />
//             <div className="contact-item">
//               <FontAwesomeIcon icon={faEnvelope} />
//               <div className="label">
//                 <p>Email:</p>
//                 <p className="email">{appsetup.email}</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="abs_div">
//         <div className="container p-0">
//           <Navbar
//             expand="lg"
//             className="main-navbar"
//             collapseOnSelect
//             expanded={expanded}
//             onToggle={() => setExpanded(!expanded)}
//           >
//             <Navbar.Toggle
//               aria-controls="basic-navbar-nav"
//               onClick={() => setExpanded(expanded ? false : "expanded")}
//               className=""
//             />

//             <Navbar.Collapse id="main-navbar-nav">
//               <Nav className="main-nav-links">
//                 <Nav.Link
//                   as={NavLink}
//                   to="/"
//                   onClick={() => setExpanded(false)}
//                 >
//                   Home
//                 </Nav.Link>
//                 <Nav.Link
//                   as={NavLink}
//                   to="/effects"
//                   onClick={() => setExpanded(false)}
//                 >
//                   Effects
//                 </Nav.Link>
//                 <Nav.Link
//                   as={NavLink}
//                   to="/gallery"
//                   onClick={() => setExpanded(false)}
//                 >
//                   Gallery/ Showreel
//                 </Nav.Link>
//                 <Nav.Link
//                   as={Link}
//                   to="/about-us"
//                   onClick={() => setExpanded(false)}
//                   className={`nav-link ${
//                     location.pathname.startsWith("/about-us") ? "active" : ""
//                   }`}
//                 >
//                   About Us
//                 </Nav.Link>
//                 <Nav.Link
//                   as={NavLink}
//                   to="/blog"
//                   onClick={() => setExpanded(false)}
//                 >
//                   Blog
//                 </Nav.Link>
//                 <Nav.Link
//                   as={NavLink}
//                   to="/contact-us"
//                   onClick={() => setExpanded(false)}
//                 >
//                   Contact Us
//                 </Nav.Link>
//               </Nav>
//             </Navbar.Collapse>

//             {/*---old code --- */}
//             <div className=" nav-actions ">
//               <button
//                 className="subsidy-btn"
//                 onClick={() => navigate("/subsidy-policy")}
//               >
//                 <Dot_Lottie /> Subsidy & Policies
//               </button>
//             </div>
//           </Navbar>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Header;

import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav, Container } from "react-bootstrap";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "./Header.css";
import { IDS } from "../../utils/common";
import { Context } from "../../utils/context";
import { PowerProgress } from "../../utils/apis/homepage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
const Header = () => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  const { IMG_URL } = useContext(Context);

  const [appsetup, setAppSetup] = useState({});
  const location = useLocation();

  const getAppSetup = async () => {
    const res = await PowerProgress();

    if (res?.success) {
      setAppSetup(res?.data?.[0] || {});
    }
  };

  useEffect(() => {
    getAppSetup();
  }, []);

  return (
    <section className="header_section">
      <div className="abs_div">
        <div className="container p-0">
          <Navbar
            expand="lg"
            className="main-navbar"
            collapseOnSelect
            expanded={expanded}
          >
            {/* <div className="logo-wrapper" onClick={() => navigate("/home")}> */}
            <div className="logo-wrapper" onClick={() => navigate("/")}>
              <img
                // src={IDS?.IMG_URL + appsetup?.logo}
                src="/assets/images/newhome/homelogo.png"
                alt="logo"
                className="nav-logo"
              />
            </div>
            <Navbar.Toggle
              onClick={() => setExpanded(!expanded)}
              aria-controls="basic-navbar-nav"
            />

            <Navbar.Collapse>
              <div className="top-section">
                <div className="l-wrapper">
                  <img src="/assets/images/newhome/mobile-menu.png" />
                </div>
                <h5 className="heading"> FALCON SFX</h5>
                <div className="close-btn" onClick={() => setExpanded(false)}>
                  <FontAwesomeIcon icon={faXmark} />
                </div>
              </div>
              <Nav className="main-nav-links mx-auto">
                <Nav.Link
                  as={NavLink}
                  // to="/home"
                  to="/"
                  onClick={() => setExpanded(false)}
                >
                  Home
                </Nav.Link>

                <Nav.Link
                  as={NavLink}
                  to="/effects"
                  onClick={() => setExpanded(false)}
                >
                  Effects
                </Nav.Link>

                <Nav.Link
                  as={NavLink}
                  // to="/gallery"
                  to="/gallery-showcase"
                  onClick={() => setExpanded(false)}
                >
                  Gallery/Showreel
                </Nav.Link>

                <Nav.Link
                  as={NavLink}
                  to="/about-us"
                  onClick={() => setExpanded(false)}
                  className={`nav-link ${
                    location.pathname.startsWith("/about-us") ? "active" : ""
                  }`}
                >
                  About Us
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/blog"
                  onClick={() => setExpanded(false)}
                  className={`nav-link ${
                    location.pathname.startsWith("/blog") ? "active" : ""
                  }`}
                >
                  Blogs
                </Nav.Link>

                <Nav.Link
                  as={NavLink}
                  to="/contact-us"
                  onClick={() => setExpanded(false)}
                >
                  Contact Us
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </div>
      </div>
    </section>
  );
};

export default Header;
